import { render, staticRenderFns } from "./contracts-register.vue?vue&type=template&id=77aa407e"
import script from "./contracts-register.vue?vue&type=script&lang=js"
export * from "./contracts-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports